/* eslint-disable react/prop-types, consistent-return */
import React from 'react'

import { NestedWrapper } from './FadeInWrapper.style'

function NestedFadeInWrapper({ children, delay = 0, simple = false, enabled, ...otherProps }) {
  return (
    <NestedWrapper {...otherProps} data-nested-wrapper isVisible enabled={enabled} delay={delay} simple={simple}>
      {children}
    </NestedWrapper>
  )
}

export default NestedFadeInWrapper